<mc-dialog (closeEvent)="close()">
  <div class="confirm-dialog">
    @if (isSiteHaveSubscription) {
      <div class="dialog-title">
        <mat-icon class="icon" svgIcon="site"></mat-icon>
        <p>Deleting this site could expose you to legal risk.</p>
      </div>
      <div class="dialog-info">
        <p class="subheader">Site: {{ siteUrl }}</p>
        <p>
          When you remove accessibility features from your site, you might make it less usable for people with
          disabilities and less compliant. The AI-Powered Widget fixes your website code 24/7 and updates the latest
          accessibility standards up to WCAG 2.2. We recommend not leaving your site vulnerable to accessibility
          violations and legal risk as your content evolves.
        </p>
      </div>
    } @else {
      <div class="dialog-title">
        <mat-icon class="icon" svgIcon="site"></mat-icon>
        <p>Are you sure you want to delete this website from the dashboard?</p>
      </div>
      <div class="dialog-info">
        <p class="subheader">Site: {{ siteUrl }}</p>
        <p>
          Remember, you won’t be able to run or manage the Widget on a website removed from the dashboard. Once you
          remove the embed script directly from the website's code, the Widget stops displaying and performing its
          functions to improve usability and compliance.
        </p>
      </div>
    }

    <div class="dialog-actions">
      <mc-button (clickEvent)="close()" variant="stroked" color="primary">Cancel</mc-button>
      <mc-button (clickEvent)="confirm()" variant="flat" color="primary">{{
        isSiteHaveSubscription ? 'Manage Subscription' : 'Delete site'
      }}</mc-button>
    </div>
  </div>
</mc-dialog>
